import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
    containerForm: {
        marginBottom: "20px",
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    paper: {
        padding: theme.spacing(5),
        margin: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.primary,
    },
    form: {
        // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    submit: {
        margin: theme.spacing(3, 0, 2),
        backgroundImage: `linear-gradient(to right, #00d2ff 0%, #3a7bd5  51%, #00d2ff  100%)`,
        backgroundSize: "200% auto",
        display: "block",
        width: "100%",
    },

    chipContainer: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },

    selectedServiceChip: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.text,
        fontWeight: "bolder"
    },
    dividerGrid: {
        marginTop: "5px",
        marginBottom: "5px"
    },
    divider: {
        borderColor: theme.palette.primary.main,
        width: "100%",
        height: "10px",
    },
    // Activity Logs Tab styles
    activityTabContainer: {
        padding: theme.spacing(3),
    },
    activityTable: {
        marginTop: theme.spacing(2),
    },
    loginChip: {
        backgroundColor: theme.palette.success?.light || '#81c784',
        minWidth: 90,
    },
    logoutChip: {
        backgroundColor: theme.palette.grey?.[400] || '#bdbdbd',
        minWidth: 90,
    }

}));
